/* функция забирает реальные размеры "img-crop-wrap" и прописывает их в CSS свойства в виде конечных значений в пикселях (т.к. кроп конлфиктует каким-то образом, если ширины заданы через css calc)*/
const setImgCropWrapParams = () => {
  let wrapWidth = $('.img-crop-wrap').width(),
    wrapHeight = $('.img-crop-wrap').height();
  $('.img-crop-wrap').width(wrapWidth);
  $('.img-crop-wrap').height(wrapHeight);
};

const setSrcToImgCrop = (element) => {
  /* скрипт подставляет полноразмерную картинку в модалку кропа по нажатию на иконку редактирования*/
  /* полноразмерна картинка берётся из атрибута 'data-edit-img' элементов 'edit-img-small__img-wrap' в случае если клик происходит по иконке редактирования маленьких превьюшек, и из атрибута src элемента 'edit-img-main__img если клик происходит по клику иконки редактирования большой картинки'*/
  let imgSrc;
  if (element.hasClass('edit-img-main__controls-item')) {
    imgSrc = element
      .closest('.edit-img-main')
      .find('.edit-img-main__img')
      .attr('src');
  } else if (element.hasClass('edit-img-small__controls-item')) {
    imgSrc = element.closest('.edit-img-small__img-wrap').attr('data-edit-img');
  }
  $('.img-crop-orig').attr('src', imgSrc);
  $('#img-crop').attr('src', $('.img-crop-orig').attr('src'));
};

/* скрипт задаёт размеры подставленной картинки с учётом того, что в зависимости от пропорций и ориентации картинка должна быть растянута либо на 100% по ширине контейнера либо на 100% по высоте контейнера */
const setImageSizeAccordingToOriginalRatio = () => {
  let imgCropOrig = $('.img-crop-orig'),
    imgCrop = $('#img-crop'),
    orig_w = imgCropOrig.width(),
    orig_h = imgCropOrig.height(),
    imgCropRatio = orig_w / orig_h,
    wrapWidth = $('.img-crop-wrap').width(),
    wrapHeight = $('.img-crop-wrap').height() - 16;
  if (orig_w > orig_h) {
    imgCrop.css({
      width: wrapWidth + 'px',
      height: wrapWidth / imgCropRatio + 'px',
    });
  } else {
    if (wrapWidth / wrapHeight >= imgCropRatio) {
      imgCrop.css({
        width: wrapHeight * imgCropRatio + 'px',
        height: wrapHeight + 'px',
      });
    } else {
      imgCrop.css({
        width: wrapWidth + 'px',
        height: wrapWidth / imgCropRatio + 'px',
      });
    }
  }
};

$(document).on('click touch', '.js-set-img-to-crop', function (e) {
  setSrcToImgCrop($(this));
  setTimeout(function () {
    setImgCropWrapParams();
  }, 50);
  setTimeout(function () {
    setImageSizeAccordingToOriginalRatio();
  }, 100);
});
function clearImgCropSrc() {
  $('#img-crop, .img-crop-orig').attr({
    src: '',
    style: '',
  });
}
$(document).on('click', '.mdl--img-crop .w-mdl-close', function () {
  clearImgCropSrc();
  // $('#img-crop').attr({
  //   src: '',
  //   style: '',
  // });
});

$(window).on('resize orientationchange', function () {
  setTimeout(() => {
    setImgCropWrapParams();
  }, 50);
  setTimeout(function () {
    setImageSizeAccordingToOriginalRatio();
  }, 100);
});
